export const tarsUrl = '/api/tars2/file/upload/getUploadFileScrip';
export const defaultOssUploadService = { url: tarsUrl };
